import React, { PureComponent } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { Icon } from 'semantic-ui-react';
import { ModalTemplate, Button as Btn } from 'components';

import { CtExamAttachEdit } from 'containers';

import classNames from 'classnames/bind';
import styles from './ExamAttachEditModal.css';
const cx = classNames.bind(styles);

class ExamAttachEditModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      editInvalid: false,
      editOnProgress: true,
      editSaveNow: false,
      disableSave: false,
      editSize: null
    };
  }

  setDisableSave = value => {
    const stateObj = {};
    if (this.state.disableSave !== value) {
      stateObj.disableSave = value;
    }
    if (!value && this.state.editSaveNow) {
      stateObj.editSaveNow = false;
    }
    this.setState(stateObj);
  };

  setEditInvalid = value => {
    if (this.state.editInvalid !== value) {
      const stateObj = {
        editInvalid: value
      };
      this.setState(stateObj);
    }
  };

  setEditOnProgress = value => {
    if (this.state.editOnProgress !== value) {
      this.setState({ editOnProgress: value });
    }
  };

  setSizeToggle = () => {
    if (this.state.editSize === 'fullscreen') {
      this.setState({
        editSize: null
      });
    } else {
      this.setState({
        editSize: 'fullscreen'
      });
    }
  };

  dispatchSave = () => {
    this.setState({
      editSaveNow: true
    });
  };

  cancleAction = () => {
    const { addMode, mountEditModal } = this.props;

    mountEditModal();
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { disableSave, editInvalid, editOnProgress, editSaveNow, editSize } = this.state;
    const { isAuth, templateInfo, addMode, mountEditModal } = this.props;
    const { setDisableSave, setEditInvalid, setEditOnProgress, dispatchSave, cancleAction, setSizeToggle } = this;

    const { attachInfoNo } = templateInfo;

    return (
      <ModalTemplate
        size={editSize}
        closeOnEscape={false}
        closeOnDimmerClick={false}
        closeOnDocumentClick={false}
        className={cx('modal-template-edit', 'modal-admin', !!editSize ? 'full-size-modal' : '')}
        closeIcon={<Icon name="close" link onClick={cancleAction} />}
        onToggleModal={mountEditModal}
        visible
        scrolling
        header={
          <div className={cx('modal-custom-header')}>
            <div>
              {addMode
                ? defineMessages(formatMessage({ id: 'AdminMenu_10', defaultMessage: '첨부파일 등록' }))
                : defineMessages(formatMessage({ id: 'AdminMenu_11', defaultMessage: '첨부파일 수정' }))}
            </div>
            <Icon
              name={!!editSize ? 'compress' : 'expand'}
              link
              className={cx('bt-resize-modal')}
              onClick={setSizeToggle}
            />
          </div>
        }
        buttons={
          <div>
            <Btn
              buttonColor="#3cb482"
              loading={editOnProgress}
              disabled={disableSave && (editInvalid || editOnProgress)}
              onClick={dispatchSave}>
              {defineMessages(formatMessage({ id: 'ExamTemplateEditModal_5', defaultMessage: '저장' }))}
            </Btn>
            <Btn buttonColor="#eeeeee" onClick={cancleAction}>
              {defineMessages(formatMessage({ id: 'ExamTemplateEditModal_4', defaultMessage: '취소' }))}
            </Btn>
          </div>
        }>
        <CtExamAttachEdit
          addMode={addMode}
          templateInfo={templateInfo}
          editSaveNow={editSaveNow}
          setEditInvalid={setEditInvalid}
          setEditOnProgress={setEditOnProgress}
          setDisableSave={setDisableSave}
          handleOnToggleEditModal={mountEditModal}
        />
      </ModalTemplate>
    );
  }
}

ExamAttachEditModal.propTypes = {
  //
};
ExamAttachEditModal.defaultProps = {
  //
};

export default injectIntl(ExamAttachEditModal);



// WEBPACK FOOTER //
// ./src/script/components/examAttach/ExamAttachEditModal_origin.js